import MobileDetect from 'mobile-detect'

const md = new MobileDetect(window.navigator.userAgent)
const os = md.os()

class BodyScrollLock {
	body: HTMLElement
	html: HTMLElement
	scrollY: number
	isIosDevice: boolean

	constructor() {
		this.body = document.body
		this.html = document.documentElement
		this.scrollY = 0
		this.isIosDevice = os === 'iOS' || os === 'iPadOS'
	}

	public disableBodyScroll = (isFixingPosition = true): Promise<void> =>
		new Promise((resolve) => {
			// capture scroll position
			this.scrollY = window.scrollY
			this.body.style.overflow = 'hidden'
			this.body.style.paddingRight = '0px'
			this.body.classList.add('scroll-lock-enabled')

			if (this.isIosDevice && isFixingPosition) {
				this.body.style.position = 'fixed'
				this.body.style.left = '0'
				this.body.style.height = `${window.innerHeight - 1}px`
				this.body.style.boxSizing = 'border-box'
				this.html.style.overflow = 'hidden'
				this.html.style.height = `${window.innerHeight - 1}px`
				this.html.style.boxSizing = 'border-box'
			}
			resolve()
		})

	public enableBodyScroll = (): Promise<void> =>
		new Promise((resolve) => {
			this.body.removeAttribute('style')
			this.html.removeAttribute('style')
			this.body.classList.remove('scroll-lock-enabled')

			window.scrollTo(0, this.scrollY)
			resolve()
		})
}

export default new BodyScrollLock()
